import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 主题清单（与 tokens.css 中 html[data-theme=...] 对应）
// ocean 为默认（无 data-theme 即该主题），其余在 tokens.css 有覆盖块。
export const THEME_LIST = [
  {
    id: 'ocean',
    name: '深空青缘',
    desc: '青蓝主色 · 深海暗底（默认）',
    // 色板圆点：底色 + 主色（用于切换器显示）
    swatch: ['#0d1a26', '#00b8d4'],
    dark: true
  },
  {
    id: 'midnight',
    name: '午夜幽蓝',
    desc: '纯净深蓝 · 弱化青色',
    swatch: ['#0d1220', '#5478ff'],
    dark: true
  },
  {
    id: 'violet',
    name: '紫罗兰',
    desc: '暗底 · 紫色主色',
    swatch: ['#160f26', '#9b6dff'],
    dark: true
  },
  {
    id: 'rosewood',
    name: '暮色玫瑰',
    desc: '暖红棕底 · 玫瑰金主色',
    swatch: ['#1a1210', '#e0765a'],
    dark: true
  },
  {
    id: 'forest',
    name: '墨绿琥珀',
    desc: '深墨绿底 · 琥珀主色',
    swatch: ['#0f1613', '#b8a24c'],
    dark: true
  },
  {
    id: 'teal',
    name: '深海',
    desc: '深青绿底 · 青碧主色',
    swatch: ['#0b1918', '#20b2aa'],
    dark: true
  },
  {
    id: 'cyber',
    name: '霓虹',
    desc: '近黑底 · 电光青紫',
    swatch: ['#08070f', '#7b5cff'],
    dark: true
  },
  {
    id: 'light',
    name: '晨光',
    desc: '浅色 · 明亮青蓝',
    swatch: ['#f5f8fa', '#0087a8'],
    dark: false
  },
  {
    id: 'ivory',
    name: '云端',
    desc: '暖米白浅色 · 琥珀点缀',
    swatch: ['#fbf8f2', '#b07b3a'],
    dark: false
  },
  {
    id: 'berry',
    name: '马卡龙·莓果',
    desc: '粉蓝底 · 莓果粉',
    swatch: ['#fcf6f8', '#e06a8d'],
    dark: false
  },
  {
    id: 'peach',
    name: '马卡龙·蜜桃',
    desc: '奶油底 · 蜜桃杏',
    swatch: ['#fef8f2', '#f08f6a'],
    dark: false
  },
  {
    id: 'mint',
    name: '马卡龙·薄荷',
    desc: '薄荷绿底 · 薄荷青',
    swatch: ['#f4fbf8', '#4cc2a0'],
    dark: false
  },
  {
    id: 'lavender',
    name: '马卡龙·薰衣草',
    desc: '淡紫底 · 薰衣草紫',
    swatch: ['#f9f7fd', '#9a84d6'],
    dark: false
  },
  {
    id: 'lemon',
    name: '马卡龙·柠檬',
    desc: '淡黄底 · 柠檬黄',
    swatch: ['#fdfaf1', '#d9a921'],
    dark: false
  },
  {
    id: 'charcoal-gold',
    name: '炭黑·金',
    desc: '炭黑底 · 金色主色',
    swatch: ['#17150f', '#e0b64c'],
    dark: true
  },
  {
    id: 'bluegray',
    name: '蓝·浅灰·白',
    desc: '蓝主色 · 浅灰底 · 白卡片',
    swatch: ['#eef2f6', '#3a6ea5'],
    dark: false
  },
  {
    id: 'navyorange',
    name: '深蓝·橙',
    desc: '深蓝底 · 橙色主色',
    swatch: ['#0c1424', '#f08a3a'],
    dark: true
  },
  {
    id: 'mintivory',
    name: '薄荷·米白',
    desc: '薄荷绿 · 米白底',
    swatch: ['#fbf8ef', '#3aa876'],
    dark: false
  },
  {
    id: 'charcoally',
    name: '炭黑·青霓虹',
    desc: '深灰黑底 · 青霓虹',
    swatch: ['#0d0f12', '#00e5c3'],
    dark: true
  },
  {
    id: 'seafoam-light',
    name: '青灰·枣褐（浅）',
    desc: '浅青底 · 红棕主色',
    swatch: ['#eefbfa', '#c86a68'],
    dark: false
  },
  {
    id: 'seafoam-dark',
    name: '青灰·枣褐（深）',
    desc: '深青灰底 · 青绿主色',
    swatch: ['#101c1e', '#7fc5ca'],
    dark: true
  },
  {
    id: 'cocoa-light',
    name: '咖啡·蓝灰（浅）',
    desc: '米白底 · 橙棕主色',
    swatch: ['#f6f4ef', '#a56539'],
    dark: false
  },
  {
    id: 'cocoa-dark',
    name: '咖啡·蓝灰（深）',
    desc: '深咖啡底 · 蓝灰主色',
    swatch: ['#1c1713', '#96afcb'],
    dark: true
  },
  {
    id: 'mid-gray',
    name: '云雾灰',
    desc: '中间调 · 灰蓝',
    swatch: ['#3a3f46', '#58718c'],
    dark: false
  },
  {
    id: 'mid-sea',
    name: '锡兰青',
    desc: '中间调 · 青绿',
    swatch: ['#354042', '#3f8075'],
    dark: false
  },
  {
    id: 'mid-clay',
    name: '暖陶',
    desc: '中间调 · 陶土棕',
    swatch: ['#423a34', '#a0664a'],
    dark: false
  },
  {
    id: 'mid-moss',
    name: '苔绿',
    desc: '中间调 · 苔绿',
    swatch: ['#3a4135', '#6d8f4e'],
    dark: false
  },
  {
    id: 'mid-graphite',
    name: '石墨蓝',
    desc: '中间调 · 石墨蓝',
    swatch: ['#313842', '#4e74a8'],
    dark: false
  }
]

const STORAGE_KEY = 'sjui-theme'

/** 把主题 id 应用为 html[data-theme=...] */
function applyThemeId(id) {
  const root = document.documentElement
  if (!id || id === 'ocean') {
    // 默认主题无需 data-theme
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', id)
  }
}

export const useThemeStore = defineStore('theme', () => {
  const stored = (() => {
    try {
      const v = localStorage.getItem(STORAGE_KEY)
      if (v && THEME_LIST.some(t => t.id === v)) return v
    } catch (e) { /* ignore */ }
    return 'ocean'
  })()

  const currentId = ref(stored)

  // 启动时立即应用持久化主题（避免闪一下默认色）
  if (typeof document !== 'undefined') applyThemeId(currentId.value)

  const current = computed(() => THEME_LIST.find(t => t.id === currentId.value) || THEME_LIST[0])
  const isDark = computed(() => !!current.value.dark)

  /** 切换主题并持久化 */
  function setTheme(id) {
    if (!THEME_LIST.some(t => t.id === id)) return
    currentId.value = id
    applyThemeId(id)
    try { localStorage.setItem(STORAGE_KEY, id) } catch (e) { /* ignore */ }
  }

  return { THEME_LIST, currentId, current, isDark, setTheme }
})
